'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CloseCircleFilled = _interopRequireDefault(require('./lib/icons/CloseCircleFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CloseCircleFilled;
exports.default = _default;
module.exports = _default;